'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var PickupLocationHoursDisclosure_module = require('./PickupLocationHoursDisclosure.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const PickupLocationHoursDisclosure = ({
  featureName,
  hours
}) => {
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const [open, setOpen] = React.useState(false);
  const {
    locationHideStoreHours,
    locationSeeStoreHours
  } = nthHookTranslations.useTranslations();
  const {
    captiontextDefaultNone,
    linksNoneDefault: linkDefault,
    linksNoneHover: linkHover
  } = nthHookTheme.useTheme();
  if (!(hours && hours?.length)) return null;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: PickupLocationHoursDisclosure_module["default"].root
  }, /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    linkStyle: {
      sDefault: linkDefault,
      sHover: linkHover
    },
    onClick: () => {
      setOpen(!open);
      const clickDescription = open ? nthHookContextAnalytics.NarvarClickSubTypes.PICKUP_LOCATION_HIDE_HOURS_LINK : nthHookContextAnalytics.NarvarClickSubTypes.PICKUP_LOCATION_SHOW_HOURS_LINK;
      logEvent({
        clickCategory: clickDescription,
        clickLinkLabel: open ? locationHideStoreHours : locationSeeStoreHours,
        clickSubType: clickDescription,
        clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
        eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
        eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION,
        eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
        feature: featureName,
        pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_PICKUP_LOCATION
      });
    },
    "aria-expanded": open,
    "aria-controls": "store-hours-list"
  }, open ? locationHideStoreHours : locationSeeStoreHours), open && /*#__PURE__*/React__default["default"].createElement("ul", {
    id: "store-hours-list",
    className: PickupLocationHoursDisclosure_module["default"].hoursList,
    style: captiontextDefaultNone
  }, hours.map(hour => hour.hoursRange ? /*#__PURE__*/React__default["default"].createElement("li", {
    className: PickupLocationHoursDisclosure_module["default"].hoursListItem,
    key: hour.day
  }, /*#__PURE__*/React__default["default"].createElement("p", {
    className: PickupLocationHoursDisclosure_module["default"].hoursListItemDetail
  }, hour.day), /*#__PURE__*/React__default["default"].createElement("p", {
    className: PickupLocationHoursDisclosure_module["default"].hoursListItemDetail
  }, hour.hoursRange)) : /*#__PURE__*/React__default["default"].createElement("li", {
    className: PickupLocationHoursDisclosure_module["default"].hoursListItem,
    key: hour.day
  }, /*#__PURE__*/React__default["default"].createElement("p", {
    className: PickupLocationHoursDisclosure_module["default"].hoursListItemDetail
  }, hour.day), /*#__PURE__*/React__default["default"].createElement("p", {
    className: PickupLocationHoursDisclosure_module["default"].hoursListItemDetail
  }, "CLOSED")))));
};
var PickupLocationHoursDisclosure$1 = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(PickupLocationHoursDisclosure, {
  themeTokens: ['captiontextDefaultNone', 'linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: ['locationHideStoreHours', 'locationSeeStoreHours']
});

exports["default"] = PickupLocationHoursDisclosure$1;
